<template>
  <svg
    :fill="fill"
    :width="width"
    viewBox="0 0 120 30">
    <circle
      v-for="item in definition"
      :key="`circle-${item.cx}`"
      :cx="item.cx"
      cy="15"
      r="8"
      fill-opacity="0">
      <animate
        :begin="item.begin"
        :dur="dur"
        attributeName="r"
        from="8"
        to="8"
        values="8;15;15;8"
        calcMode="linear"
        repeatCount="indefinite"
      />
      <animate
        :begin="item.begin"
        :dur="dur"
        attributeName="fill-opacity"
        from=".2"
        to=".2"
        values=".2;.9;.9;.2"
        calcMode="linear"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      required: false,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      required: false,
      default: '100%',
    },
    duration: {
      type: String,
      required: false,
      default: '1.2s', // 1.6s is also a nice default value; 0.8s is a little too fast
    },
    initialDelay: {
      type: String,
      required: false,
      default: '0s',
    },
  },
  computed: {
    /**
     * `definition` defines the variations for each circle we loop in the template
     */
    definition() {
      return [
        { cx: 15, begin: this.determineStartTime(0) },
        { cx: 60, begin: this.determineStartTime(0.3) }, // could be this.dur * (1/3) but results aren't nice
        { cx: 105, begin: this.determineStartTime(0.6) }, // could be this.dur * (2/3) but results aren't nice
      ];
    },
    dur() {
      /**
       * Minimum duration of 1 second is needed otherwise
       * it looks too weird because we delay the start with
       * this.definition[x].begin
       */
      const minDuration = Math.max(1, parseFloat(this.duration));
      return `${minDuration}s`;
    },
  },
  methods: {
    determineStartTime(offset) {
      const calculatedStartTime = (parseFloat(this.dur) * offset) + parseFloat(this.initialDelay);
      const roundedStartTime = Math.round((calculatedStartTime + Number.EPSILON) * 100) / 100;
      return `${roundedStartTime}s`;
    },
  },
};
</script>
